<template>
  <v-card class="mb-4">
    <v-card-title>
      <span>{{ client.clientName }}</span
      ><v-spacer />
      <client-form
        edit
        :key="'edit' + container + storage + client.clientId"
        :container="container"
        :storage="storage"
        :clientId="client.clientId"
        :clientName="client.clientName"
        :permissions="clientPermissions"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on">
              mdi-pencil
            </v-icon>
          </template>
          <span>Edit {{ client.clientName }}</span>
        </v-tooltip>
      </client-form>
      <client-form
        :key="'copy' + container + storage + client.clientId"
        :container="container"
        :storage="storage"
        :clientName="client.clientName"
        :permissions="clientPermissions"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on">
              mdi-content-copy
            </v-icon>
          </template>
          <span>Copy {{ client.clientName }}</span>
        </v-tooltip>
      </client-form>
      <client-confirm-delete
        :container="container"
        :storage="storage"
        :client="client"
      >
        <v-icon color="red">
          mdi-trash-can
        </v-icon>
      </client-confirm-delete>
    </v-card-title>
    <v-card-subtitle>{{ client.clientId }}</v-card-subtitle>
    <v-divider></v-divider>
    <v-card-actions>
      <permissions-tags :permisisons="client.permissions"></permissions-tags>
    </v-card-actions>
  </v-card>
</template>
<script>
import PermissionsTags from './PermissionsTags.vue'
import ClientForm from './ClientForm.vue'
import ClientConfirmDelete from './ClientConfirmDelete.vue'

export default {
  components: { PermissionsTags, ClientForm, ClientConfirmDelete },
  name: 'ClientCard',
  props: {
    client: {
      type: Object,
      required: true
    },
    storage: {
      type: String,
      require: true
    },
    container: {
      type: String,
      require: true
    }
  },
  computed: {
    clientPermissions() {
      return this.client.permissions.split(',')
    }
  }
}
</script>
